import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const getFilesFromBlob = (serialNumber) => {
  return Helpers.get(`${Constants.FILE_TRANSFER_URL}/files/${serialNumber}`);
};

export const deleteFileFromBlob = (blobUrl) => {
  let query = {
    blobUrl: blobUrl,
  };

  return Helpers.delete(`${Constants.FILE_TRANSFER_URL}/`, {}, query);
};

export const getBlobUrlWithSasToken = (serialNumber, fileName) => {
  let query = {
    serialNumber: serialNumber,
    fileName: fileName,
  };

  return Helpers.get(`${Constants.FILE_TRANSFER_URL}/sasToken/fileUpload`, {}, query);
};

export const notifyInstrument = (blobUrl, serialNumber) => {
  let query = {
    blobUrl: blobUrl,
    serialNumber: serialNumber,
  };

  return Helpers.get(`${Constants.FILE_TRANSFER_URL}`, {}, query);
};

export const requestFileFromInstrument = (serialNumber, filePathConfigs) => {
  let query = {
    instrumentSerialNumber: serialNumber,
    from: null,
    to: null,
  };

  return Helpers.post(`${Constants.FILE_TRANSFER_URL}`, {}, filePathConfigs, query);
};

export const requestLogFileFromInstrument = (serialNumber, dateFrom, dateTo, filePathConfigs) => {
  let query = {
    instrumentSerialNumber: serialNumber,
    from: dateFrom,
    to: dateTo,
  };

  return Helpers.post(`${Constants.FILE_TRANSFER_URL}`, {}, filePathConfigs, query);
};

export const getFileTransferConfig = (serialNumber) => {
  return Helpers.get(`${Constants.FILE_TRANSFER_URL}/configuration/${serialNumber}`);
};

export const getReadOnlyBlobSasToken = (blobUrl) => {
  let query = {
    blobUrl: blobUrl,
  };

  return Helpers.get(`${Constants.FILE_TRANSFER_URL}/sasToken`, {}, query);
};
